import {
    get_commesse,
    get_commessa,
    create_commessa,
    update_commessa,
    get_posizioni,
    get_posizione,
    create_posizione,
    update_posizione,
} from "@/api/api.commesse.js";

const commesse = {
    namespaced: true,

    state: {
        lista: [],
        corrente: null,
        posizioni: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => { state.lista = lista; },
        SET_CORRENTE: (state, commessa) => { state.corrente = commessa; },
        SET_POSIZIONI: (state, posizioni) => { state.posizioni = posizioni; },
    },

    actions: {
        carica({ commit }, search) {
            return new Promise((resolve, reject) => {
                get_commesse(search).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_commessa(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        crea({ dispatch }, dati) {
            return new Promise((resolve, reject) => {
                create_commessa(dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        aggiorna({ dispatch }, { id, dati }) {
            return new Promise((resolve, reject) => {
                update_commessa(id, dati).then(resp => {
                    dispatch("caricaDettaglio", id);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaPosizioni({ commit }, commessaId) {
            return new Promise((resolve, reject) => {
                get_posizioni(commessaId).then(resp => {
                    commit("SET_POSIZIONI", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaPosizione(_ctx, { commessaId, id }) {
            return get_posizione(commessaId, id);
        },

        creaPosizione({ dispatch }, { commessaId, dati }) {
            return new Promise((resolve, reject) => {
                create_posizione(commessaId, dati).then(resp => {
                    dispatch("caricaPosizioni", commessaId);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        aggiornaPosizione({ dispatch }, { commessaId, id, dati }) {
            return new Promise((resolve, reject) => {
                update_posizione(commessaId, id, dati).then(resp => {
                    dispatch("caricaPosizioni", commessaId);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
        corrente: state => state.corrente,
        posizioni: state => state.posizioni,
    },
};

export default commesse;
